import httpClient from "@/api/httpClient";
import { checkIsTokenExpired } from "@/utils/tokenUtils";
import { getUserDataFromLocalStorage, safeLocalStorage } from "@/utils";
import authVersionService from "../services/authVersionService";
import { versionHeaderKeys } from "../constants";

let isRefreshing = false;
let subscribers: ((token: string) => void)[] = [];
let failedRequests: ((error: any) => void)[] = [];

function subscribeTokenRefresh(onSuccess: (token: string) => void, onError: (error: any) => void) {
  subscribers.push(onSuccess);
  failedRequests.push(onError);
}

function onRefreshed(token: string) {
  subscribers.forEach((cb) => cb(token));
  subscribers = [];
  failedRequests = [];
}

function onRefreshFailed(error: any) {
  failedRequests.forEach((cb) => cb(error));
  subscribers = [];
  failedRequests = [];
}

export function setupAuthRequestInterceptor() {
  httpClient.interceptors.request.use(
    async (config) => {
      const savedUser = getUserDataFromLocalStorage();
      const token = savedUser?.token;

      if (token && checkIsTokenExpired(token)) {
        if (!isRefreshing) {
          isRefreshing = true;

          authVersionService
            .authenticate()
            .then((data) => {
              const newToken = data.token;
              onRefreshed(newToken);
              return newToken;
            })
            .catch((err) => {
              authVersionService.clearHeaders();
              safeLocalStorage.removeItem("user");
              onRefreshFailed(err);
              return Promise.reject(err);
            })
            .finally(() => {
              isRefreshing = false;
            });
        }

        return new Promise((resolve) => {
          subscribeTokenRefresh(
            (newToken) => {
              if (config.headers) {
                config.headers.common[versionHeaderKeys.default] = `Bearer ${newToken}`;
              }
              resolve(config);
            },
            () => {
              resolve(config);
            }
          );
        });
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
}
